export default __webpack_public_path__ + "static/media/left hammer.d5ccb6c6.png";